import React, { useMemo } from "react";

import Checkbox from "antd/es/checkbox";
import Form from "antd/es/form";
import { defineMessages, useIntl } from "react-intl";

import stageIcon from "@app/assets/icons/deal-stage-dark.svg";
import StageSelectBox from "@app/component/input/StageSelectBox";
import CardConfigurationProps from "@app/scene/dashboard/types/CardConfigurationProps";
import DealRottingCriteriaOptions from "@app/types/dashboard/cards/openStageDealAmount/DealRottingCriteriaOptions";
import isOpenStage from "@app/util/isOpenStage";

import styles from "./CriteriaFormComponent.module.scss";

const messages = defineMessages({
  dealsNotRotting: {
    id: "dashboard.editModal.criteria.openStageDealAmount.dealsNotRotting",
    defaultMessage: "Deals that are <b>not</b> rotting",
    description: "Amount radio button title",
  },
  dealsRotting: {
    id: "dashboard.editModal.criteria.openStageDealAmount.dealsRotting",
    defaultMessage: "Deals that are rotting",
    description: "Adjusted Amount radio button title",
  },
  label: {
    id: "dashboard.editModal.criteria.openStageDealAmount.label",
    defaultMessage: "Amount is made up of:",
    description: "Amount radio buttons label",
  },
  stages: {
    id: "dashboard.editModal.criteria.openStageDealAmount.stages",
    defaultMessage: "Stages(s)",
    description:
      "Title of the Stages field in a criteria form in Edit Open Stage Deals Amount Modal on Dashboard",
  },
});

interface Props extends CardConfigurationProps {}

const CriteriaFormComponent: React.FC<Props> = () => {
  const intl = useIntl();

  const options = useMemo(
    () => [
      {
        label: intl.formatMessage(messages.dealsRotting),
        value: DealRottingCriteriaOptions.DEALS_ROTTING,
      },
      {
        label: intl.formatMessage(messages.dealsNotRotting, { b: (text) => <b>{text}</b> }),
        value: DealRottingCriteriaOptions.DEALS_NOT_ROTTING,
      },
    ],
    [intl]
  );

  return (
    <div>
      <Form.Item label={intl.formatMessage(messages.stages)} name={["criteria", "dealStageIds"]}>
        <StageSelectBox
          allowClear
          filterStages={isOpenStage}
          prefixIcon={<img alt="stage icon" src={stageIcon} />}
          size="large"
        />
      </Form.Item>
      <Form.Item label={intl.formatMessage(messages.label)} name={["criteria", "rottingOptions"]}>
        <Checkbox.Group className={styles.checkboxes} options={options} />
      </Form.Item>
    </div>
  );
};

export default CriteriaFormComponent;
